(function(){
  /* Reveal custom sections on scroll */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -60px 0px' });
    const scan = () => document.querySelectorAll('.tp-reveal:not(.is-in)').forEach((el) => io.observe(el));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
    document.addEventListener('shopify:section:load', scan);
  } else {
    document.querySelectorAll('.tp-reveal').forEach((el) => el.classList.add('is-in'));
  }
})();
